module.exports = __webpack_public_path__ + "img/pokemon-trainer-min.5d6f0ce8.png";